<template>
  <main class="home" v-if="Object.keys(home).length > 0">
    <section
      id="splash"
      v-scroll-to="{
        el: '#quote',
        duration: 1000,
        offset: 0
      }"
    >
      <div class="slideshow">
            <div ref="slide" class="slide active">
                  <img :src="home.images.url" data-sizes="auto" :srcset="home.images.srcset" alt="Aspekt Office - Landing">
            </div>
      </div>
      <img
        :class="{ active: showLogo }"
        class="logo"
        src="/public/assets/aspekt-office-1line-white.svg"
      />
    </section>
    <section id="quote" class="pad-x pad-b pad-t">
      <div class="w-text">
        <p v-html="home.about"></p>
      </div>
    </section>
    <section class="slideshow" v-show="home.projects">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="project in home.projects" :key="project.uid">
          <router-link
            :to="{ name: 'project', params: { id: project.uid } }"
            class="slide"
            :class="project.files.orientation"
          >
            <img :src="project.files.url" :alt="project.title" />
            <p class="title caption uppercase">
              {{ project.title
              }}<span class="hide">
                ({{ project.year }}) {{ project.category }} ↑</span
              >
            </p>
          </router-link>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev">&larr;</div>
        <div class="swiper-button-next" slot="button-next">&rarr;</div>
      </swiper>
    </section>
  </main>
</template>

<script>
export default {
  metaInfo: {
    title: "Aspekt Office",
    titleTemplate: null
  },
  data() {
    return {
      showLogo: true,
      sIndex: 0,
      swiperOption: {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1.5
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  computed: {
    home() {
      return this.$store.state.home;
    },
    video() {
      let videos = this.home.files;
      if (videos.length > 0) {
        let videoCount = videos.length;
        let randomNum = Math.floor(Math.random() * videoCount);
        return videos[randomNum];
      } else {
        return videos[0];
      }
    }
  },
  mounted() {
      window.addEventListener("scroll", this.onScroll);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
      random(images) {
            // let random = Math.floor(Math.random() * images.length);
            return images;
      },
      onScroll() {
            if (window.scrollY > window.innerHeight / 3) {
                  this.showLogo = false;
            } else {
                  this.showLogo = true;
            }
      }
  }
};
</script>

<style lang="scss">
section {
  &#quote {
    padding: calc(4 * var(--lh)) calc(2 * var(--lh)) !important;
    margin: 0 !important;
    text-align: center;
  }
  &#splash {
    width: 100vw;
    height: 100vh;
    position: relative;
    background: black;
    cursor: pointer;
    overflow: hidden;
    .slideshow {
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      color:white;
      .slide {
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            visibility: hidden;
            opacity: 0;
            transition: visibility 0.5s, opacity 0.5s;
            &.active {
                  visibility: visible;
                  opacity: 1;
            }
            img {
                  width:100%;
                  height:100%;
                  object-fit: cover;
            }
      }
    }
    video {
      margin: auto;
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 0;
      transform: translate(0%, -50%);
      visibility: visible;
      opacity: 1;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 0;
    }
    .logo {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
      width: 30vmin;
      opacity: 0;
      transition: opacity 0.5s;
      &.active {
        opacity: 1;
      }
    }
  }
}
.slide {
  .hide {
    opacity: 0;
    transition: opacity 0.5s;
  }
  &:hover {
    color: black !important;
    .hide {
      opacity: 1;
    }
  }
}
.clients {
  grid-column: span 3 !important;
  padding: 0 calc(2 * var(--lh));
}
.client {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  a {
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-block;
    h3 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
  }
}
</style>
